import { iWidgetChatConfig } from "../models/interfaceChatWidget";
import { iProConfigDatastore, iProIntegration, iProProjectMain, ValidationOption } from "../models/interfaceProject";
import { iUserLoginInfo } from "../models/interfaceUserLogin";
import { IntegrationType } from "./enums";

 
export function getDefaultProProjectMain(TypeLayout:string,TypeEnv:string): iProProjectMain {
  
  return {
    chatbot: {
      created_date: "",
      created_user: "",
      deleted: false,
      description: "",
      domain: "",
      id: "",
      name: "R2D2",
      param_name: "",
      param_value: "",
      type_param: "",
      updated_date: "",
      updated_user: "",
      url: "",
    },
    config: {
      config_params: {
        provider: "google/gemini",
        model_type: "basic",
        k_top_history: 10,
        k_top_retrieval: 10,
        max_minutes: 10,
        max_token_history: 1000,
        model_name: "",
        temperature: 0.4,

      },
      datastores: [] as iProConfigDatastore[],
      id: "",
      prompt_params: {
        assistant_name: "",
        assistant_role: "",
        company_activity: "",
        company_name: "",
        conversation_purpose: "",
        welcome_message: "",
        alias:""
      },
      tags: [],
    },
    connection: {
      created_date: "",
      created_user: "",
      deleted: false,
      description: "",
      domain: "",
      id: "",
      identity_connection: "",
      metadata: {},
      name: "",
      project: {},
      state: "CONNECT",
      type: "PLAYGROUND",
      url: "",
    },
    docs: [ 
    ],
    project: {
      business_case: "", // estatico vacio
      company_code:"",
      company_name:"",
      alias:"",
      chatbot: "", // determinado en back
      chatbot_type: TypeLayout,   // determinado al momento de guardar
      cloud_resource: {}, // objeto vacio
      connections: [], // array vacion determinado en back
      created_date: "",// back
      created_user: "",// back
      deleted: false,// back
      deployed: true, // Estatico en true
      description: "Establece una descripción para tu proyecto",// play 
      domain: "", //back
      id: null,// back
      private_access: false,// estatico
      loggin_disabled:false,
      generic_access:false,
      generic_access_detail: {
        label: "",
        placeholder: "",
        validation: [],
      },

      project_name: "Crea/Edita tu proyecto",//
      updated_date: "",
      updated_user: "",
      version_active: "",
      permissions:[], 
      chpro_integrations:getDefaultProProjecIntegration(),
      evaluation:{active:false,metrics:[], extra_params:[]},
      env:TypeEnv,
      monitor: {
        development: {
          count_users: 10,
          total_cost: 0.02,
          total_questions: 24,
          total_tokens: 510,
        },
      }, // estatico 
      notifications: [],
      quota:0,
      users:[],
      groups:[] 
    },
    qa:[]
  };
}
 
export function getDefaultProProjecIntegration(): iProIntegration[] {
  const defaultIntegrations = Object.values(IntegrationType).map((type) => {
    if(type==IntegrationType.Whatsapp){
      return{ 
        type: type,
        active: false,
        account_id: "",
        graph_api_token: "",
        edit: false,
      }
    }
    if(type==IntegrationType.Azure_bot){
      return{ 
        type: type,
        active: false,
        account_id: "",
        app_id: "",
        secret: "",
        edit: false,
      }
    } 
    if(type==IntegrationType.Supplier){
      return{ 
        type:type,
        active: false,
        account_id:""
      }
    }
    if(type==IntegrationType.Embed){
      return{ 
        type:type,
        active: false,
        account_id:"",
        props: getDefaultWidgetChatConfig()
      }
    }
    return {
      type:type,
      active: false,
      account_id:""
    }
  }); 
  return defaultIntegrations;
} 


export function getDefaultWidgetChatConfig(): iWidgetChatConfig {
   return {
          button: {
            width: "48px",
            height: "48px",
            backgroundColor: "#ff2929",
            color: "#ffffff",
            borderRadius: "9999px",
            fontSize: "14px",
            fontWeight: "600",
            iconSize: "30px",
            iconColor: "#ffffff",
            text:"",
            iconSvg: `
              <svg xmlns='http://www.w3.org/2000/svg' fill='none'
                viewBox='0 0 24 24' stroke='currentColor'>
                <path stroke-linecap='round' stroke-linejoin='round' stroke-width='2'
                  d='M12 14h.01M8 10h.01M16 10h.01
                    M21 12c0 4.418-4.03 8-9 8
                    -1.402 0-2.72-.29-3.857-.802L3 20l1.288-3.943
                    C3.463 14.708 3 13.39 3 12
                    c0-4.418 4.03-8 9-8s9 3.582 9 8z'/>
              </svg>
            `,
            position: {
              bottom: "20px",
              right: "20px"
            },
            tooltip: {
              text: "Estamos para escucharte y apoyarte ¡Consúltame!",
              backgroundColor: "#111827",
              color: "#ffffff",
              fontSize: "12px", 
              borderRadius: "6px",
              width: "100px",
              height:"50px",
              position:"izquierdo" //"izquierdo"|"arriba"|"abajo"|"derecho"
            }
          },
          iframe: {
            width: "360px",
            height: "500px",
            borderRadius: "12px",
            borderColor: "#ccc",
            backgroundColor: "#ffffff"
          
          }
        };
   
} 

/*
export function getDefaultProProjectMain(TypeLayout:string): iProProjectMain {
  return {
    chatbot: {
      created_date: "Tue, 28 Jan 2025 16:23:00 GMT",
      created_user: "oquispep@inside.com.pe",
      deleted: false,
      description: "Agente automatizado en Azure.",
      domain: "intercorp.com.pe",
      id: "WxHmBxlvlw0S5KAgKxJk",
      name: "R2D2_Azure",
      param_name: "token",
      param_value: "projects/877374341472/secrets/dev-itcdo-ialab-tokenbot-sct-ghtr/versions/latest",
      type_param: "HEADER",
      updated_date: "Wed, 05 Feb 2025 02:46:48 GMT",
      updated_user: "oquispep@inside.com.pe",
      url: "https://itcm-ialabs-chatbot-bot2.agreeablerock-6d6ad838.eastus.azurecontainerapps.io/conversation",
    },
    config: {
      config_params: {
        k_top_history: 7,
        k_top_retrieval: 2,
        max_minutes: 10,
        max_token_history: 200,
        model_name: "",
        temperature: 0.2,
      },
      datastores: ["inca-ai-intercorp-dev-innova-testing"],
      id: "3NngMHFdhXRI30eErjVO",
      prompt_params: {
        assistant_name: "Bot",
        assistant_role: "Bot Informativo",
        company_activity: "Empresa prestadora de servicios de Educacion.",
        company_name: "Innova Schools",
        conversation_purpose: "- Atender las consultas de los usuarios con muchos ánimos y responder de forma concisa.\n- Si el usuario hace preguntas ambiguas puedes solicitarle información que consideres relevante.",
      },
      tags: [],
    },
    connection: {
      created_date: "Tue, 29 Oct 2024 03:31:11 GMT",
      created_user: "oquispep@inside.com.pe",
      deleted: false,
      description: "Pruebas localhost",
      domain: "intercorp.com.pe",
      id: "48BXZUSPgj2aCgax3BHK",
      identity_connection: "",
      metadata: {},
      name: "Mi Playground Localhost",
      project: {},
      state: "CONNECT",
      type: "PLAYGROUND",
      url: "http://localhost:3000",
    },
    docs: [
      {
        chunk_overlap: 40,
        chunk_size: 2000,
        created_date: "Wed, 11 Dec 2024 22:45:58 GMT",
        datacenter_id: "iZG0vOpoMFfRJmYIMQ4l",
        deleted: false,
        domain: "intercorp.com.pe",
        file_id: "ATVm8uB3ZfLquCVYVUnu",
        file_size: 3516439,
        file_type: "application/pdf",
        file_url:"https://storage.googleapis.com/download/storage/v1/b/central-data-governance-260223.appspot.com/o/inca-itcm-chatbot-datacenter%2Fintercorp.com.pe%2Finca-ai-intercorp-dev-innova-testing%2Fangular.pdf20241211174558?generation=1733957158936270&alt=media",
        name: "angular.pdf",
        type: TypeFile.Pdf,
        seleccionado: false, // Se agregó este campo
        columns: [], // Se agregó este campo
        embedded_column: "", // Se agregó este campo
      },
      {
        chunk_overlap: 40,
        chunk_size: 2000,
        created_date: "Tue, 03 Dec 2024 16:04:44 GMT",
        datacenter_id: "iZG0vOpoMFfRJmYIMQ4l",
        deleted: false,
        domain: "intercorp.com.pe",
        file_id: "RlfJjDBydYZInmVTtTkt",
        file_size: 37818,
        file_type: "application/pdf",
        file_url:
          "https://storage.googleapis.com/download/storage/v1/b/central-data-governance-260223.appspot.com/o/inca-itcm-chatbot-datacenter%2Fintercorp.com.pe%2Finca-ai-intercorp-dev-innova-testing%2FAsunto.pdf20241203110444?generation=1733241884265810&alt=media",
        name: "Asunto.pdf",
        type: TypeFile.Pdf,
        seleccionado: false, // Se agregó este campo
        columns: [], // Se agregó este campo
        embedded_column: "", // Se agregó este campo
      },
    ],
    project: {
      business_case: "", // estatico vacio
      chatbot: "WxHmBxlvlw0S5KAgKxJk", // determinado en back
      chatbot_type: TypeLayout,   // determinado al momento de guardar
      cloud_resource: {}, // objeto vacio
      connections: ["OeRisKbTkNcRJL7o6u0x", "48BXZUSPgj2aCgax3BHK", "DVvLO8G1ON2LgjF5dPaj"], // array vacion determinado en back
      created_date: "Tue, 03 Dec 2024 16:15:44 GMT",// back
      created_user: "rcoronado@inside.com.pe",// back
      deleted: false,// back
      deployed: true, // Estatico en true
      description: "Chatbot de prueba",// play 
      domain: "intercorp.com.pe", //back
      id: "sgduNAL17tTIh3KoRmia",// back
      monitor: {
        development: {
          count_users: 10,
          total_cost: 0.02,
          total_questions: 24,
          total_tokens: 510,
        },
      }, // estatico 
      private_access: false,// estatico
      project_name: "nombre proyecto",//
      updated_date: "Wed, 12 Feb 2025 14:05:54 GMT",
      updated_user: "oquispep@inside.com.pe",
      version_active: "3NngMHFdhXRI30eErjVO",
    },
  };
}
*/

export function getTestDataTable():any{
  return [
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Información General",
      "categoria": "GENERAL",
      "keywords": ["INFORMACIÓN GENERAL"]
    },
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Ubicacion",
      "categoria": "GENERAL",
      "keywords": ["Ubicacion del Hotel Asociado"]
    },
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Formas de Pago",
      "categoria": "PAGOS",
      "keywords": [
        "TIPO DE MONEDA",
        "TARJETAS DE CRÉDITO",
        "NÚMEROS DE CUENTA EN MONEDA EXTRANJERA",
        "NÚMEROS DE CUENTA EN MONEDA NACIONAL",
        "CÓDIGOS INTERBANCARIOS EN MONEDA EXTRANJERA",
        "CÓDIGOS INTERBANCARIOS EN MONEDA NACIONAL"
      ]
    },
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Servicios General",
      "categoria": "SERVICIOS",
      "keywords": [
        "GENERALES OBSERVACIONES",
        "RECREACIÓN/ESPARCIMIENTO"
      ]
    },
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Salas de Eventos",
      "categoria": "SERVICIOS",
      "keywords": ["SALAS DE EVENTOS"]
    },
    {
      "hotel": "Asociado La Xalca",
      "contexto": "Tipo de Habitacion",
      "categoria": "HABITACION",
      "keywords": [
        "TRADICIONAL MATRIMONIAL",
        "SUPERIOR MATRIMONIAL",
        "TRADICIONAL DOBLE",
        "TRADICIONAL TRIPLE",
        "SUPERIOR TRIPLE FAMILIAR"
      ]
    }
  ]
  
}



export function getDefaultSchema(type:string): any { 
  return{
      form_id:crypto.randomUUID(),
      type:type, 
      view_edit:true,
      schema :{      
            title: "",
            method: "POST",
            action: "",
            enctype: "application/json",
            labelButton: "",
            fields: [] as FieldFrm[]
          }
      };
    } 



export function getDataTable():any{
  return [
    {
      "answers": "test",
      "questions": "como me afilio / como puedo afiliarme / quiero afiliarme / que requisitos piden para la afiliación / quiero crearme una cuenta para utilizar izipay / quiero utilizar izipay / quiero crearme una cuenta por primera vez",
      "row_id": "gfCBcsC2LFVO7y4hfoJX"
    },
    {
      "answers": "Para iniciar sesión en la APP izipay, selecciona la opción 'Iniciar Sesión' y proporciona tu correo y contraseña. Si no has recibido tus credenciales, puedes hacer clic en '¿Olvidaste tu contraseña?' para recuperarlas.",
      "questions": "como me loggeo al app / como ingresar al app / como ingreso al app",
      "row_id": "1wte2FKYsm3qzg1v1TDp"
    },
    {
      "answers": "Puedes realizar ventas desde la APP izipay ingresando el monto de venta y seleccionando la opción de pago, ya sea con tarjeta, QR, pago Link o Pago Efectivo . Asegúrate de tener la versión adecuada de Android y tecnología NFC si eliges pagar con tu celular.",
      "questions": "como vendo desde mi app / vender con el app / como vendo con el app / como hago ventas desde mi app",
      "row_id": "TmG36qhTdLNOFgVt6qXL"
    },
    {
      "answers": "Para cobrar con tu POS izi Jr, simplemente acerca, inserta o desliza la tarjeta. Luego, envía el voucher por redes sociales, correo o SMS a tu cliente.",
      "questions": "como cobrar con mi pos / quiero cobrar con mi pos / cobrar con pos ",
      "row_id": "MCE2rKhihU6K3BME7zi4"
    },
    {
      "answers": "Si deseas cobrar con tu celular, primero ingresa el monto de venta, acerca la tarjeta a la parte posterior de tu dispositivo y luego envía el voucher por redes sociales, correo o SMS.",
      "questions": "como cobrar desde mi celular / cobrar desde mi teléfono / como cobrar con mi telefono",
      "row_id": "jtTObARQlHWGea5OtSVV"
    },
    {
      "answers": "Para vender utilizando códigos QR, selecciona la opción 'QR' y digita el monto a cobrar. Luego, indica a tu cliente que escanee el código QR con su billetera móvil. Cuando se realice el pago, recibirás una notificación de confirmación.",
      "questions": "como vendo con qr / quiero cobrar con qr / no se como cobrar con qr / como uso mi codigo qr",
      "row_id": "SfmcUfUh1xuC0byI0Bbv"
    },
    {
      "answers": "Si prefieres que tu cliente coloque el monto a pagar, selecciona 'Mi QR' desde la home de la APP izipay e indica a tu cliente que escanee tu QR con su billetera móvil. Recibirás una notificación cuando se realice el pago.",
      "questions": "como utilizo mi codigo qr / para que sirve el qr / para que es mi codigo qr / que puedo hacer con mi codigo qr / quiero utilizar mi qr",
      "row_id": "e6EYG7ltZR49iF4gMxNy"
    },
    {
      "answers": "Para cobrar utilizando PagoEfectivo, selecciona la opción 'PagoEfectivo', ingresa el monto de venta y la fecha de expiración del código que estás generando. Luego, comparte el código CIP por redes sociales, correo o SMS.",
      "questions": "como vendo con pago efectivo / como vender con pago efectivo / como cobro con pago efectivo / como cobrar con pago efectivo/ quiero usar pago efectivo ",
      "row_id": "bxmEmMztCrMCUfE0KwTL"
    },
    {
      "answers": "Si prefieres usar enlaces de pago, selecciona la opción 'Link', ingresa el monto de venta y la fecha de expiración del link que estás generando. Luego, comparte el link por redes sociales, correo o SMS.",
      "questions": "como cobrar con link de pago / como cobrar con pagolink / quiero cobrar con link / quiero cobrar con pago link/ como vender con link de pago / quiero vender con pagolink",
      "row_id": "VaL0JQCN1Dur3WOcFu3e"
    },
    {
      "answers": "Para acceder a tus abonos y fondos de ventas, puedes utilizar las opciones de Retiro inmediato o Retiro en 24 horas desde la sección 'Tu saldo disponible'.",
      "questions": "como retiro mis abonos / como veo mi saldo / como veo mis abonos / cuanto me van a abonar / quiero conocer mi abono",
      "row_id": "Le2pMI2jDzFk8pZM8tWU"
    }
  ];
}






export function getValidationOptions():ValidationOption[]{
  return [
    { tipo: "required", label: "Requerido", requiresValue: false },
    { tipo: "minLength", label: "Longitud mínima", requiresValue: true, placeholder: "Ej: 3" },
    { tipo: "maxLength", label: "Longitud máxima", requiresValue: true, placeholder: "Ej: 10" },
    { tipo: "pattern", label: "Expresión regular", requiresValue: true, placeholder: "^[0-9]+$" },
    { tipo: "min", label: "Valor mínimo", requiresValue: true, placeholder: "Ej: 1" },
    { tipo: "max", label: "Valor máximo", requiresValue: true, placeholder: "Ej: 100" },
    { tipo: "email", label: "Formato email", requiresValue: false },
    { tipo: "numeric", label: "Solo números", requiresValue: false },
    { tipo: "list", label: "Listado permitido", requiresValue: true, placeholder: "ID_LISTADO" },
  ];
}

